import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './Download.css'; // Use global Download.css
import { t } from '../i18n'; // NEW import

const Download = () => {
  const { id } = useParams(); // Get the upload ID from the URL
  const [data, setData] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isLoading, setIsLoading] = useState(true); // Track if the next image is loading
  const [loadedImage, setLoadedImage] = useState(''); // Store the currently loaded image

  useEffect(() => {
    // Fetch the upload details from the server
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/upload/details/${id}`);
        if (!response.ok) throw new Error('Failed to fetch upload details');
        const result = await response.json();
        setData(result);
      } catch (error) {
        console.error('Error fetching upload details:', error);
      }
    };

    fetchData();
  }, [id]);

  useEffect(() => {
    if (!data?.coverPhotos?.length) return;

    // Preload the current image
    const preloadImage = (url) => {
      const img = new Image();
      img.src = url;
      img.onload = () => {
        setLoadedImage(url); // Update the loaded image when it's fully loaded
        setIsLoading(false); // Remove the loading state
      };
    };

    setIsLoading(true); // Set loading state before switching to the next slide
    preloadImage(data.coverPhotos[currentSlide]);
  }, [currentSlide, data]);

  useEffect(() => {
    // Slideshow logic: Automatically change slides every 5 seconds
    const interval = setInterval(() => {
      if (data?.coverPhotos?.length) {
        setCurrentSlide((prev) => (prev + 1) % data.coverPhotos.length);
      }
    }, 5000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [data]);

  const handleDownloadComplete = async () => {
    try {
      await fetch(`${process.env.REACT_APP_SERVER_URL}/upload/notify-download/${id}`, {
        method: 'POST',
      });
    } catch (error) {
      console.error('Error notifying server about download completion:', error);
    }
  };

  if (!data) {
    return <div className="download-container">{t('en', 'downloading') /* default while loading */}</div>;
  }

  const lang = data.language || 'en'; // NEW: language from server
  const { title, senderName, message, signedUrl, expiration } = data;
  const formattedExpiration = new Date(expiration).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });

  return (
    <div className="download-container" dir={lang === 'he' ? 'rtl' : 'ltr'}> {/* CHANGED: set dir by language */}
      {/* Background layer */}
      <div
        className="download-background"
        style={{
          backgroundImage: `url(${loadedImage})`, // Use the preloaded image
          filter: isLoading ? 'blur(20px)' : 'none', // Apply blur while loading
        }}
      ></div>

      {/* Content layer */}
      <div className="download-content">
        <h1 className="download-title">{title}</h1>
        <h2 className="download-sender-name">{senderName}</h2>
        <p className="download-formatted-message">{message}</p>
        <p className="download-expiration">{t(lang, 'linkExpires')} {formattedExpiration}.</p>
        <a
          href={signedUrl}
          className="download-button"
          download={title ? `${title.replace(/[^a-zA-Z0-9.\-_]/g, '_')}.zip` : 'download.zip'}
          onClick={handleDownloadComplete}
        >
          {t(lang, 'downloadButton')}
        </a>
      </div>

      {/* Branding */}
      <div className="download-branding">
        <img
          src={`${process.env.PUBLIC_URL}/clickzLogo.png`}
          alt="Clickz Logo"
          className="download-branding-logo"
        />
        <p className="download-branding-text">{t(lang, 'poweredBy')}</p>
      </div>
    </div>
  );
};

export default Download;
